// Auto-generated icon registry
module.exports = {
  "CANONICAL_KEYS": [
    "arrow-arrow-circle-down",
    "arrow-arrow-circle-down-left",
    "arrow-arrow-circle-down-right",
    "arrow-arrow-circle-left",
    "arrow-arrow-circle-right",
    "arrow-arrow-circle-up",
    "arrow-arrow-circle-up-left",
    "arrow-arrow-circle-up-right",
    "arrow-arrow-down-lg",
    "arrow-arrow-down-left-lg",
    "arrow-arrow-down-left-md",
    "arrow-arrow-down-left-sm",
    "arrow-arrow-down-md",
    "arrow-arrow-down-right-lg",
    "arrow-arrow-down-right-md",
    "arrow-arrow-down-right-sm",
    "arrow-arrow-down-sm",
    "arrow-arrow-down-up",
    "arrow-arrow-left-lg",
    "arrow-arrow-left-md",
    "arrow-arrow-left-right",
    "arrow-arrow-left-sm",
    "arrow-arrow-reload-02",
    "arrow-arrow-right-lg",
    "arrow-arrow-right-md",
    "arrow-arrow-right-sm",
    "arrow-arrow-sub-down-left",
    "arrow-arrow-sub-down-right",
    "arrow-arrow-sub-left-down",
    "arrow-arrow-sub-left-up",
    "arrow-arrow-sub-right-down",
    "arrow-arrow-sub-right-up",
    "arrow-arrow-sub-up-left",
    "arrow-arrow-sub-up-right",
    "arrow-arrow-undo-down-left",
    "arrow-arrow-undo-down-right",
    "arrow-arrow-undo-up-left",
    "arrow-arrow-undo-up-right",
    "arrow-arrow-up-lg",
    "arrow-arrow-up-left-lg",
    "arrow-arrow-up-left-md",
    "arrow-arrow-up-left-sm",
    "arrow-arrow-up-md",
    "arrow-arrow-up-right-lg",
    "arrow-arrow-up-right-md",
    "arrow-arrow-up-right-sm",
    "arrow-arrow-up-sm",
    "arrow-arrows-reload-01",
    "arrow-caret-circle-down",
    "arrow-caret-circle-left",
    "arrow-caret-circle-right",
    "arrow-caret-circle-up",
    "arrow-caret-down-md",
    "arrow-caret-down-sm",
    "arrow-caret-left-sm",
    "arrow-caret-right-sm",
    "arrow-caret-up-md",
    "arrow-caret-up-sm",
    "arrow-chevron-down",
    "arrow-chevron-down-duo",
    "arrow-chevron-left",
    "arrow-chevron-left-duo",
    "arrow-chevron-left-md",
    "arrow-chevron-right",
    "arrow-chevron-right-duo",
    "arrow-chevron-right-md",
    "arrow-chevron-up",
    "arrow-chevron-up-duo",
    "arrow-expand",
    "arrow-shrink",
    "arrow-unfold-less",
    "arrow-unfold-more",
    "calendar-alarm",
    "calendar-calendar",
    "calendar-calendar-add",
    "calendar-calendar-check",
    "calendar-calendar-close",
    "calendar-calendar-days",
    "calendar-calendar-event",
    "calendar-calendar-remove",
    "calendar-calendar-week",
    "calendar-clock",
    "calendar-timer",
    "calendar-timer-add",
    "calendar-timer-close",
    "calendar-timer-remove",
    "communication-bell",
    "communication-bell-add",
    "communication-bell-close",
    "communication-bell-notification",
    "communication-bell-off",
    "communication-bell-remove",
    "communication-bell-ring",
    "communication-chat",
    "communication-chat-add",
    "communication-chat-check",
    "communication-chat-circle",
    "communication-chat-circle-add",
    "communication-chat-circle-check",
    "communication-chat-circle-close",
    "communication-chat-circle-dots",
    "communication-chat-circle-remove",
    "communication-chat-close",
    "communication-chat-conversation",
    "communication-chat-conversation-circle",
    "communication-chat-dots",
    "communication-chat-remove",
    "communication-mail",
    "communication-mail-open",
    "communication-paper-plane",
    "communication-phone",
    "communication-share-android",
    "communication-share-ios-export",
    "edit-add-column",
    "edit-add-minus-square",
    "edit-add-plus",
    "edit-add-plus-circle",
    "edit-add-plus-square",
    "edit-add-row",
    "edit-add-to-queue",
    "edit-bold",
    "edit-close-circle",
    "edit-close-square",
    "edit-columns",
    "edit-combine-cells",
    "edit-copy",
    "edit-crop",
    "edit-delete-column",
    "edit-delete-row",
    "edit-double-quotes-l",
    "edit-double-quotes-r",
    "edit-edit-pencil-01",
    "edit-edit-pencil-02",
    "edit-edit-pencil-line-01",
    "edit-edit-pencil-line-02",
    "edit-figma",
    "edit-font",
    "edit-heading",
    "edit-heading-h1",
    "edit-heading-h2",
    "edit-heading-h3",
    "edit-heading-h4",
    "edit-heading-h5",
    "edit-heading-h6",
    "edit-hide",
    "edit-italic",
    "edit-layer",
    "edit-layers",
    "edit-list-add",
    "edit-list-check",
    "edit-list-checklist",
    "edit-list-ordered",
    "edit-list-remove",
    "edit-list-unordered",
    "edit-mention",
    "edit-move",
    "edit-move-horizontal",
    "edit-move-vertical",
    "edit-paperclip-attechment-horizontal",
    "edit-paperclip-attechment-tilt",
    "edit-paragraph",
    "edit-path",
    "edit-redo",
    "edit-remove-minus",
    "edit-remove-minus-circle",
    "edit-rows",
    "edit-ruler",
    "edit-select-multiple",
    "edit-show",
    "edit-single-quotes-l",
    "edit-single-quotes-r",
    "edit-sort-ascending",
    "edit-sort-descending",
    "edit-strikethrough",
    "edit-swatches-palette",
    "edit-table",
    "edit-table-add",
    "edit-table-remove",
    "edit-text",
    "edit-text-align-center",
    "edit-text-align-justify",
    "edit-text-align-left",
    "edit-text-align-right",
    "edit-underline",
    "edit-undo",
    "environment-bulb",
    "environment-coffe-to-go",
    "environment-coffee",
    "environment-cookie",
    "environment-cupcake",
    "environment-first-aid",
    "environment-leaf",
    "environment-moon",
    "environment-planet",
    "environment-puzzle",
    "environment-rainbow",
    "environment-sun",
    "environment-water-drop",
    "file-archive",
    "file-cloud",
    "file-cloud-add",
    "file-cloud-check",
    "file-cloud-close",
    "file-cloud-download",
    "file-cloud-off",
    "file-cloud-remove",
    "file-cloud-upload",
    "file-download-package",
    "file-file-add",
    "file-file-blank",
    "file-file-check",
    "file-file-close",
    "file-file-code",
    "file-file-document",
    "file-file-download",
    "file-file-edit",
    "file-file-remove",
    "file-file-search",
    "file-file-upload",
    "file-files",
    "file-folder",
    "file-folder-add",
    "file-folder-check",
    "file-folder-close",
    "file-folder-code",
    "file-folder-document",
    "file-folder-download",
    "file-folder-edit",
    "file-folder-open",
    "file-folder-remove",
    "file-folder-search",
    "file-folder-upload",
    "file-folders",
    "file-note",
    "file-note-edit",
    "file-note-search",
    "file-notebook",
    "interface-book",
    "interface-book-open",
    "interface-bookmark",
    "interface-chart-bar-horizontal-01",
    "interface-chart-bar-vertical-01",
    "interface-chart-line",
    "interface-chart-pie",
    "interface-check",
    "interface-check-all",
    "interface-check-all-big",
    "interface-check-big",
    "interface-checkbox-check",
    "interface-checkbox-fill",
    "interface-checkbox-unchecked",
    "interface-command",
    "interface-credit-card-01",
    "interface-credit-card-02",
    "interface-download",
    "interface-drag-horizontal",
    "interface-drag-vertical",
    "interface-dummy-circle",
    "interface-dummy-circle-small",
    "interface-dummy-square",
    "interface-dummy-square-small",
    "interface-exit",
    "interface-external-link",
    "interface-filter",
    "interface-filter-off",
    "interface-gift",
    "interface-handbag",
    "interface-heart-01",
    "interface-heart-02",
    "interface-instance",
    "interface-label",
    "interface-line-l",
    "interface-line-m",
    "interface-line-s",
    "interface-line-xl",
    "interface-link",
    "interface-link-break",
    "interface-link-horizontal",
    "interface-link-horizontal-off",
    "interface-link-vertical",
    "interface-loading",
    "interface-lock",
    "interface-lock-open",
    "interface-log-out",
    "interface-magnifying-glass-minus",
    "interface-magnifying-glass-plus",
    "interface-main-component",
    "interface-option",
    "interface-radio-fill",
    "interface-radio-unchecked",
    "interface-search-magnifying-glass",
    "interface-settings",
    "interface-settings-future",
    "interface-shopping-bag-01",
    "interface-shopping-bag-02",
    "interface-shopping-cart-01",
    "interface-shopping-cart-02",
    "interface-slider-01",
    "interface-slider-02",
    "interface-slider-03",
    "interface-star",
    "interface-suitcase",
    "interface-swicht-left",
    "interface-swicht-right",
    "interface-tag",
    "interface-ticket-voucher",
    "interface-trash-empty",
    "interface-trash-full",
    "interface-trending-down",
    "interface-trending-up",
    "media-airplay",
    "media-chromecast",
    "media-forward",
    "media-headphones",
    "media-image-01",
    "media-image-02",
    "media-pause",
    "media-pause-circle",
    "media-play",
    "media-play-circle",
    "media-rewind",
    "media-shuffle",
    "media-skip-back",
    "media-skip-forward",
    "media-stop",
    "media-stop-circle",
    "media-volume-max",
    "media-volume-min",
    "media-volume-minus",
    "media-volume-off",
    "media-volume-off-02",
    "media-volume-plus",
    "menu-close-lg",
    "menu-close-md",
    "menu-close-sm",
    "menu-hamburger-lg",
    "menu-hamburger-md",
    "menu-menu-alt-01",
    "menu-menu-alt-02",
    "menu-menu-alt-03",
    "menu-menu-alt-04",
    "menu-menu-alt-05",
    "menu-menu-duo-lg",
    "menu-menu-duo-md",
    "menu-more-grid-big",
    "menu-more-grid-small",
    "menu-more-horizontal",
    "menu-more-vertical",
    "navigation-building-01",
    "navigation-building-02",
    "navigation-building-03",
    "navigation-building-04",
    "navigation-car-auto",
    "navigation-compass",
    "navigation-flag",
    "navigation-globe",
    "navigation-house-01",
    "navigation-house-02",
    "navigation-house-03",
    "navigation-house-add",
    "navigation-house-check",
    "navigation-house-close",
    "navigation-house-remove",
    "navigation-map",
    "navigation-map-pin",
    "navigation-navigation",
    "shape-circle",
    "shape-octagon",
    "shape-shield",
    "shape-square",
    "shape-triangle",
    "shape-wavy",
    "system-bar-bottom",
    "system-bar-left",
    "system-bar-right",
    "system-bar-top",
    "system-camera",
    "system-code",
    "system-cylinder",
    "system-data",
    "system-desktop",
    "system-desktop-tower",
    "system-devices",
    "system-keyboard",
    "system-laptop",
    "system-mobile",
    "system-mobile-button",
    "system-monitor",
    "system-monitor-play",
    "system-mouse",
    "system-moving-desk",
    "system-printer",
    "system-qr-code",
    "system-save",
    "system-tablet",
    "system-tablet-button",
    "system-terminal",
    "system-wifi-high",
    "system-wifi-low",
    "system-wifi-medium",
    "system-wifi-none",
    "system-wifi-off",
    "system-wifi-problem",
    "system-window",
    "system-window-check",
    "system-window-close",
    "system-window-code-block",
    "system-window-sidebar",
    "system-window-terminal",
    "user-user-01",
    "user-user-02",
    "user-user-03",
    "user-user-add",
    "user-user-card-id",
    "user-user-check",
    "user-user-circle",
    "user-user-close",
    "user-user-remove",
    "user-user-square",
    "user-user-voice",
    "user-users",
    "user-users-group",
    "warning-circle-check",
    "warning-circle-help",
    "warning-circle-warning",
    "warning-help",
    "warning-info",
    "warning-octagon-check",
    "warning-octagon-help",
    "warning-octagon-warning",
    "warning-shield-check",
    "warning-shield-warning",
    "warning-square-check",
    "warning-square-help",
    "warning-square-warning",
    "warning-stop-sign",
    "warning-triangle-check",
    "warning-triangle-warning",
    "warning-warning",
    "warning-wavy-check",
    "warning-wavy-help",
    "warning-wavy-warning"
  ],
  "ICON_MAP": {
    "arrow-arrow-circle-down": "./icons/normalized/Arrow/Arrow_Circle_Down.svg",
    "arrow-arrow-circle-down-left": "./icons/normalized/Arrow/Arrow_Circle_Down_Left.svg",
    "arrow-arrow-circle-down-right": "./icons/normalized/Arrow/Arrow_Circle_Down_Right.svg",
    "arrow-arrow-circle-left": "./icons/normalized/Arrow/Arrow_Circle_Left.svg",
    "arrow-arrow-circle-right": "./icons/normalized/Arrow/Arrow_Circle_Right.svg",
    "arrow-arrow-circle-up": "./icons/normalized/Arrow/Arrow_Circle_Up.svg",
    "arrow-arrow-circle-up-left": "./icons/normalized/Arrow/Arrow_Circle_Up_Left.svg",
    "arrow-arrow-circle-up-right": "./icons/normalized/Arrow/Arrow_Circle_Up_Right.svg",
    "arrow-arrow-down-lg": "./icons/normalized/Arrow/Arrow_Down_LG.svg",
    "arrow-arrow-down-left-lg": "./icons/normalized/Arrow/Arrow_Down_Left_LG.svg",
    "arrow-arrow-down-left-md": "./icons/normalized/Arrow/Arrow_Down_Left_MD.svg",
    "arrow-arrow-down-left-sm": "./icons/normalized/Arrow/Arrow_Down_Left_SM.svg",
    "arrow-arrow-down-md": "./icons/normalized/Arrow/Arrow_Down_MD.svg",
    "arrow-arrow-down-right-lg": "./icons/normalized/Arrow/Arrow_Down_Right_LG.svg",
    "arrow-arrow-down-right-md": "./icons/normalized/Arrow/Arrow_Down_Right_MD.svg",
    "arrow-arrow-down-right-sm": "./icons/normalized/Arrow/Arrow_Down_Right_SM.svg",
    "arrow-arrow-down-sm": "./icons/normalized/Arrow/Arrow_Down_SM.svg",
    "arrow-arrow-down-up": "./icons/normalized/Arrow/Arrow_Down_Up.svg",
    "arrow-arrow-left-lg": "./icons/normalized/Arrow/Arrow_Left_LG.svg",
    "arrow-arrow-left-md": "./icons/normalized/Arrow/Arrow_Left_MD.svg",
    "arrow-arrow-left-right": "./icons/normalized/Arrow/Arrow_Left_Right.svg",
    "arrow-arrow-left-sm": "./icons/normalized/Arrow/Arrow_Left_SM.svg",
    "arrow-arrow-reload-02": "./icons/normalized/Arrow/Arrow_Reload_02.svg",
    "arrow-arrow-right-lg": "./icons/normalized/Arrow/Arrow_Right_LG.svg",
    "arrow-arrow-right-md": "./icons/normalized/Arrow/Arrow_Right_MD.svg",
    "arrow-arrow-right-sm": "./icons/normalized/Arrow/Arrow_Right_SM.svg",
    "arrow-arrow-sub-down-left": "./icons/normalized/Arrow/Arrow_Sub_Down_Left.svg",
    "arrow-arrow-sub-down-right": "./icons/normalized/Arrow/Arrow_Sub_Down_Right.svg",
    "arrow-arrow-sub-left-down": "./icons/normalized/Arrow/Arrow_Sub_Left_Down.svg",
    "arrow-arrow-sub-left-up": "./icons/normalized/Arrow/Arrow_Sub_Left_Up.svg",
    "arrow-arrow-sub-right-down": "./icons/normalized/Arrow/Arrow_Sub_Right_Down.svg",
    "arrow-arrow-sub-right-up": "./icons/normalized/Arrow/Arrow_Sub_Right_Up.svg",
    "arrow-arrow-sub-up-left": "./icons/normalized/Arrow/Arrow_Sub_Up_Left.svg",
    "arrow-arrow-sub-up-right": "./icons/normalized/Arrow/Arrow_Sub_Up_Right.svg",
    "arrow-arrow-undo-down-left": "./icons/normalized/Arrow/Arrow_Undo_Down_Left.svg",
    "arrow-arrow-undo-down-right": "./icons/normalized/Arrow/Arrow_Undo_Down_Right.svg",
    "arrow-arrow-undo-up-left": "./icons/normalized/Arrow/Arrow_Undo_Up_Left.svg",
    "arrow-arrow-undo-up-right": "./icons/normalized/Arrow/Arrow_Undo_Up_Right.svg",
    "arrow-arrow-up-lg": "./icons/normalized/Arrow/Arrow_Up_LG.svg",
    "arrow-arrow-up-left-lg": "./icons/normalized/Arrow/Arrow_Up_Left_LG.svg",
    "arrow-arrow-up-left-md": "./icons/normalized/Arrow/Arrow_Up_Left_MD.svg",
    "arrow-arrow-up-left-sm": "./icons/normalized/Arrow/Arrow_Up_Left_SM.svg",
    "arrow-arrow-up-md": "./icons/normalized/Arrow/Arrow_Up_MD.svg",
    "arrow-arrow-up-right-lg": "./icons/normalized/Arrow/Arrow_Up_Right_LG.svg",
    "arrow-arrow-up-right-md": "./icons/normalized/Arrow/Arrow_Up_Right_MD.svg",
    "arrow-arrow-up-right-sm": "./icons/normalized/Arrow/Arrow_Up_Right_SM.svg",
    "arrow-arrow-up-sm": "./icons/normalized/Arrow/Arrow_Up_SM.svg",
    "arrow-arrows-reload-01": "./icons/normalized/Arrow/Arrows_Reload_01.svg",
    "arrow-caret-circle-down": "./icons/normalized/Arrow/Caret_Circle_Down.svg",
    "arrow-caret-circle-left": "./icons/normalized/Arrow/Caret_Circle_Left.svg",
    "arrow-caret-circle-right": "./icons/normalized/Arrow/Caret_Circle_Right.svg",
    "arrow-caret-circle-up": "./icons/normalized/Arrow/Caret_Circle_Up.svg",
    "arrow-caret-down-md": "./icons/normalized/Arrow/Caret_Down_MD.svg",
    "arrow-caret-down-sm": "./icons/normalized/Arrow/Caret_Down_SM.svg",
    "arrow-caret-left-sm": "./icons/normalized/Arrow/Caret_Left_SM.svg",
    "arrow-caret-right-sm": "./icons/normalized/Arrow/Caret_Right_SM.svg",
    "arrow-caret-up-md": "./icons/normalized/Arrow/Caret_Up_MD.svg",
    "arrow-caret-up-sm": "./icons/normalized/Arrow/Caret_Up_SM.svg",
    "arrow-chevron-down": "./icons/normalized/Arrow/Chevron_Down.svg",
    "arrow-chevron-down-duo": "./icons/normalized/Arrow/Chevron_Down_Duo.svg",
    "arrow-chevron-left": "./icons/normalized/Arrow/Chevron_Left.svg",
    "arrow-chevron-left-duo": "./icons/normalized/Arrow/Chevron_Left_Duo.svg",
    "arrow-chevron-left-md": "./icons/normalized/Arrow/Chevron_Left_MD.svg",
    "arrow-chevron-right": "./icons/normalized/Arrow/Chevron_Right.svg",
    "arrow-chevron-right-duo": "./icons/normalized/Arrow/Chevron_Right_Duo.svg",
    "arrow-chevron-right-md": "./icons/normalized/Arrow/Chevron_Right_MD.svg",
    "arrow-chevron-up": "./icons/normalized/Arrow/Chevron_Up.svg",
    "arrow-chevron-up-duo": "./icons/normalized/Arrow/Chevron_Up_Duo.svg",
    "arrow-expand": "./icons/normalized/Arrow/Expand.svg",
    "arrow-shrink": "./icons/normalized/Arrow/Shrink.svg",
    "arrow-unfold-less": "./icons/normalized/Arrow/Unfold_Less.svg",
    "arrow-unfold-more": "./icons/normalized/Arrow/Unfold_More.svg",
    "calendar-alarm": "./icons/normalized/Calendar/Alarm.svg",
    "calendar-calendar": "./icons/normalized/Calendar/Calendar.svg",
    "calendar-calendar-add": "./icons/normalized/Calendar/Calendar_Add.svg",
    "calendar-calendar-check": "./icons/normalized/Calendar/Calendar_Check.svg",
    "calendar-calendar-close": "./icons/normalized/Calendar/Calendar_Close.svg",
    "calendar-calendar-days": "./icons/normalized/Calendar/Calendar_Days.svg",
    "calendar-calendar-event": "./icons/normalized/Calendar/Calendar_Event.svg",
    "calendar-calendar-remove": "./icons/normalized/Calendar/Calendar_Remove.svg",
    "calendar-calendar-week": "./icons/normalized/Calendar/Calendar_Week.svg",
    "calendar-clock": "./icons/normalized/Calendar/Clock.svg",
    "calendar-timer": "./icons/normalized/Calendar/Timer.svg",
    "calendar-timer-add": "./icons/normalized/Calendar/Timer_Add.svg",
    "calendar-timer-close": "./icons/normalized/Calendar/Timer_Close.svg",
    "calendar-timer-remove": "./icons/normalized/Calendar/Timer_Remove.svg",
    "communication-bell": "./icons/normalized/Communication/Bell.svg",
    "communication-bell-add": "./icons/normalized/Communication/Bell_Add.svg",
    "communication-bell-close": "./icons/normalized/Communication/Bell_Close.svg",
    "communication-bell-notification": "./icons/normalized/Communication/Bell_Notification.svg",
    "communication-bell-off": "./icons/normalized/Communication/Bell_Off.svg",
    "communication-bell-remove": "./icons/normalized/Communication/Bell_Remove.svg",
    "communication-bell-ring": "./icons/normalized/Communication/Bell_Ring.svg",
    "communication-chat": "./icons/normalized/Communication/Chat.svg",
    "communication-chat-add": "./icons/normalized/Communication/Chat_Add.svg",
    "communication-chat-check": "./icons/normalized/Communication/Chat_Check.svg",
    "communication-chat-circle": "./icons/normalized/Communication/Chat_Circle.svg",
    "communication-chat-circle-add": "./icons/normalized/Communication/Chat_Circle_Add.svg",
    "communication-chat-circle-check": "./icons/normalized/Communication/Chat_Circle_Check.svg",
    "communication-chat-circle-close": "./icons/normalized/Communication/Chat_Circle_Close.svg",
    "communication-chat-circle-dots": "./icons/normalized/Communication/Chat_Circle_Dots.svg",
    "communication-chat-circle-remove": "./icons/normalized/Communication/Chat_Circle_Remove.svg",
    "communication-chat-close": "./icons/normalized/Communication/Chat_Close.svg",
    "communication-chat-conversation": "./icons/normalized/Communication/Chat_Conversation.svg",
    "communication-chat-conversation-circle": "./icons/normalized/Communication/Chat_Conversation_Circle.svg",
    "communication-chat-dots": "./icons/normalized/Communication/Chat_Dots.svg",
    "communication-chat-remove": "./icons/normalized/Communication/Chat_Remove.svg",
    "communication-mail": "./icons/normalized/Communication/Mail.svg",
    "communication-mail-open": "./icons/normalized/Communication/Mail_Open.svg",
    "communication-paper-plane": "./icons/normalized/Communication/Paper_Plane.svg",
    "communication-phone": "./icons/normalized/Communication/Phone.svg",
    "communication-share-android": "./icons/normalized/Communication/Share_Android.svg",
    "communication-share-ios-export": "./icons/normalized/Communication/Share_iOS_Export.svg",
    "edit-add-column": "./icons/normalized/Edit/Add_Column.svg",
    "edit-add-minus-square": "./icons/normalized/Edit/Add_Minus_Square.svg",
    "edit-add-plus": "./icons/normalized/Edit/Add_Plus.svg",
    "edit-add-plus-circle": "./icons/normalized/Edit/Add_Plus_Circle.svg",
    "edit-add-plus-square": "./icons/normalized/Edit/Add_Plus_Square.svg",
    "edit-add-row": "./icons/normalized/Edit/Add_Row.svg",
    "edit-add-to-queue": "./icons/normalized/Edit/Add_To_Queue.svg",
    "edit-bold": "./icons/normalized/Edit/Bold.svg",
    "edit-close-circle": "./icons/normalized/Edit/Close_Circle.svg",
    "edit-close-square": "./icons/normalized/Edit/Close_Square.svg",
    "edit-columns": "./icons/normalized/Edit/Columns.svg",
    "edit-combine-cells": "./icons/normalized/Edit/Combine_Cells.svg",
    "edit-copy": "./icons/normalized/Edit/Copy.svg",
    "edit-crop": "./icons/normalized/Edit/Crop.svg",
    "edit-delete-column": "./icons/normalized/Edit/Delete_Column.svg",
    "edit-delete-row": "./icons/normalized/Edit/Delete_Row.svg",
    "edit-double-quotes-l": "./icons/normalized/Edit/Double_Quotes_L.svg",
    "edit-double-quotes-r": "./icons/normalized/Edit/Double_Quotes_R.svg",
    "edit-edit-pencil-01": "./icons/normalized/Edit/Edit_Pencil_01.svg",
    "edit-edit-pencil-02": "./icons/normalized/Edit/Edit_Pencil_02.svg",
    "edit-edit-pencil-line-01": "./icons/normalized/Edit/Edit_Pencil_Line_01.svg",
    "edit-edit-pencil-line-02": "./icons/normalized/Edit/Edit_Pencil_Line_02.svg",
    "edit-figma": "./icons/normalized/Edit/Figma.svg",
    "edit-font": "./icons/normalized/Edit/Font.svg",
    "edit-heading": "./icons/normalized/Edit/Heading.svg",
    "edit-heading-h1": "./icons/normalized/Edit/Heading_H1.svg",
    "edit-heading-h2": "./icons/normalized/Edit/Heading_H2.svg",
    "edit-heading-h3": "./icons/normalized/Edit/Heading_H3.svg",
    "edit-heading-h4": "./icons/normalized/Edit/Heading_H4.svg",
    "edit-heading-h5": "./icons/normalized/Edit/Heading_H5.svg",
    "edit-heading-h6": "./icons/normalized/Edit/Heading_H6.svg",
    "edit-hide": "./icons/normalized/Edit/Hide.svg",
    "edit-italic": "./icons/normalized/Edit/Italic.svg",
    "edit-layer": "./icons/normalized/Edit/Layer.svg",
    "edit-layers": "./icons/normalized/Edit/Layers.svg",
    "edit-list-add": "./icons/normalized/Edit/List_Add.svg",
    "edit-list-check": "./icons/normalized/Edit/List_Check.svg",
    "edit-list-checklist": "./icons/normalized/Edit/List_Checklist.svg",
    "edit-list-ordered": "./icons/normalized/Edit/List_Ordered.svg",
    "edit-list-remove": "./icons/normalized/Edit/List_Remove.svg",
    "edit-list-unordered": "./icons/normalized/Edit/List_Unordered.svg",
    "edit-mention": "./icons/normalized/Edit/Mention.svg",
    "edit-move": "./icons/normalized/Edit/Move.svg",
    "edit-move-horizontal": "./icons/normalized/Edit/Move_Horizontal.svg",
    "edit-move-vertical": "./icons/normalized/Edit/Move_Vertical.svg",
    "edit-paperclip-attechment-horizontal": "./icons/normalized/Edit/Paperclip_Attechment_Horizontal.svg",
    "edit-paperclip-attechment-tilt": "./icons/normalized/Edit/Paperclip_Attechment_Tilt.svg",
    "edit-paragraph": "./icons/normalized/Edit/Paragraph.svg",
    "edit-path": "./icons/normalized/Edit/Path.svg",
    "edit-redo": "./icons/normalized/Edit/Redo.svg",
    "edit-remove-minus": "./icons/normalized/Edit/Remove_Minus.svg",
    "edit-remove-minus-circle": "./icons/normalized/Edit/Remove_Minus_Circle.svg",
    "edit-rows": "./icons/normalized/Edit/Rows.svg",
    "edit-ruler": "./icons/normalized/Edit/Ruler.svg",
    "edit-select-multiple": "./icons/normalized/Edit/Select_Multiple.svg",
    "edit-show": "./icons/normalized/Edit/Show.svg",
    "edit-single-quotes-l": "./icons/normalized/Edit/Single_Quotes_L.svg",
    "edit-single-quotes-r": "./icons/normalized/Edit/Single_Quotes_R.svg",
    "edit-sort-ascending": "./icons/normalized/Edit/Sort_Ascending.svg",
    "edit-sort-descending": "./icons/normalized/Edit/Sort_Descending.svg",
    "edit-strikethrough": "./icons/normalized/Edit/Strikethrough.svg",
    "edit-swatches-palette": "./icons/normalized/Edit/Swatches_Palette.svg",
    "edit-table": "./icons/normalized/Edit/Table.svg",
    "edit-table-add": "./icons/normalized/Edit/Table_Add.svg",
    "edit-table-remove": "./icons/normalized/Edit/Table_Remove.svg",
    "edit-text": "./icons/normalized/Edit/Text.svg",
    "edit-text-align-center": "./icons/normalized/Edit/Text_Align_Center.svg",
    "edit-text-align-justify": "./icons/normalized/Edit/Text_Align_Justify.svg",
    "edit-text-align-left": "./icons/normalized/Edit/Text_Align_Left.svg",
    "edit-text-align-right": "./icons/normalized/Edit/Text_Align_Right.svg",
    "edit-underline": "./icons/normalized/Edit/Underline.svg",
    "edit-undo": "./icons/normalized/Edit/Undo.svg",
    "environment-bulb": "./icons/normalized/Environment/Bulb.svg",
    "environment-coffe-to-go": "./icons/normalized/Environment/Coffe_To_Go.svg",
    "environment-coffee": "./icons/normalized/Environment/Coffee.svg",
    "environment-cookie": "./icons/normalized/Environment/Cookie.svg",
    "environment-cupcake": "./icons/normalized/Environment/Cupcake.svg",
    "environment-first-aid": "./icons/normalized/Environment/First_Aid.svg",
    "environment-leaf": "./icons/normalized/Environment/Leaf.svg",
    "environment-moon": "./icons/normalized/Environment/Moon.svg",
    "environment-planet": "./icons/normalized/Environment/Planet.svg",
    "environment-puzzle": "./icons/normalized/Environment/Puzzle.svg",
    "environment-rainbow": "./icons/normalized/Environment/Rainbow.svg",
    "environment-sun": "./icons/normalized/Environment/Sun.svg",
    "environment-water-drop": "./icons/normalized/Environment/Water_Drop.svg",
    "file-archive": "./icons/normalized/File/Archive.svg",
    "file-cloud": "./icons/normalized/File/Cloud.svg",
    "file-cloud-add": "./icons/normalized/File/Cloud_Add.svg",
    "file-cloud-check": "./icons/normalized/File/Cloud_Check.svg",
    "file-cloud-close": "./icons/normalized/File/Cloud_Close.svg",
    "file-cloud-download": "./icons/normalized/File/Cloud_Download.svg",
    "file-cloud-off": "./icons/normalized/File/Cloud_Off.svg",
    "file-cloud-remove": "./icons/normalized/File/Cloud_Remove.svg",
    "file-cloud-upload": "./icons/normalized/File/Cloud_Upload.svg",
    "file-download-package": "./icons/normalized/File/Download_Package.svg",
    "file-file-add": "./icons/normalized/File/File_Add.svg",
    "file-file-blank": "./icons/normalized/File/File_Blank.svg",
    "file-file-check": "./icons/normalized/File/File_Check.svg",
    "file-file-close": "./icons/normalized/File/File_Close.svg",
    "file-file-code": "./icons/normalized/File/File_Code.svg",
    "file-file-document": "./icons/normalized/File/File_Document.svg",
    "file-file-download": "./icons/normalized/File/File_Download.svg",
    "file-file-edit": "./icons/normalized/File/File_Edit.svg",
    "file-file-remove": "./icons/normalized/File/File_Remove.svg",
    "file-file-search": "./icons/normalized/File/File_Search.svg",
    "file-file-upload": "./icons/normalized/File/File_Upload.svg",
    "file-files": "./icons/normalized/File/Files.svg",
    "file-folder": "./icons/normalized/File/Folder.svg",
    "file-folder-add": "./icons/normalized/File/Folder_Add.svg",
    "file-folder-check": "./icons/normalized/File/Folder_Check.svg",
    "file-folder-close": "./icons/normalized/File/Folder_Close.svg",
    "file-folder-code": "./icons/normalized/File/Folder_Code.svg",
    "file-folder-document": "./icons/normalized/File/Folder_Document.svg",
    "file-folder-download": "./icons/normalized/File/Folder_Download.svg",
    "file-folder-edit": "./icons/normalized/File/Folder_Edit.svg",
    "file-folder-open": "./icons/normalized/File/Folder_Open.svg",
    "file-folder-remove": "./icons/normalized/File/Folder_Remove.svg",
    "file-folder-search": "./icons/normalized/File/Folder_Search.svg",
    "file-folder-upload": "./icons/normalized/File/Folder_Upload.svg",
    "file-folders": "./icons/normalized/File/Folders.svg",
    "file-note": "./icons/normalized/File/Note.svg",
    "file-note-edit": "./icons/normalized/File/Note_Edit.svg",
    "file-note-search": "./icons/normalized/File/Note_Search.svg",
    "file-notebook": "./icons/normalized/File/Notebook.svg",
    "interface-book": "./icons/normalized/Interface/Book.svg",
    "interface-book-open": "./icons/normalized/Interface/Book_Open.svg",
    "interface-bookmark": "./icons/normalized/Interface/Bookmark.svg",
    "interface-chart-bar-horizontal-01": "./icons/normalized/Interface/Chart_Bar_Horizontal_01.svg",
    "interface-chart-bar-vertical-01": "./icons/normalized/Interface/Chart_Bar_Vertical_01.svg",
    "interface-chart-line": "./icons/normalized/Interface/Chart_Line.svg",
    "interface-chart-pie": "./icons/normalized/Interface/Chart_Pie.svg",
    "interface-check": "./icons/normalized/Interface/Check.svg",
    "interface-check-all": "./icons/normalized/Interface/Check_All.svg",
    "interface-check-all-big": "./icons/normalized/Interface/Check_All_Big.svg",
    "interface-check-big": "./icons/normalized/Interface/Check_Big.svg",
    "interface-checkbox-check": "./icons/normalized/Interface/Checkbox_Check.svg",
    "interface-checkbox-fill": "./icons/normalized/Interface/Checkbox_Fill.svg",
    "interface-checkbox-unchecked": "./icons/normalized/Interface/Checkbox_Unchecked.svg",
    "interface-command": "./icons/normalized/Interface/Command.svg",
    "interface-credit-card-01": "./icons/normalized/Interface/Credit_Card_01.svg",
    "interface-credit-card-02": "./icons/normalized/Interface/Credit_Card_02.svg",
    "interface-download": "./icons/normalized/Interface/Download.svg",
    "interface-drag-horizontal": "./icons/normalized/Interface/Drag_Horizontal.svg",
    "interface-drag-vertical": "./icons/normalized/Interface/Drag_Vertical.svg",
    "interface-dummy-circle": "./icons/normalized/Interface/Dummy_Circle.svg",
    "interface-dummy-circle-small": "./icons/normalized/Interface/Dummy_Circle_Small.svg",
    "interface-dummy-square": "./icons/normalized/Interface/Dummy_Square.svg",
    "interface-dummy-square-small": "./icons/normalized/Interface/Dummy_Square_Small.svg",
    "interface-exit": "./icons/normalized/Interface/Exit.svg",
    "interface-external-link": "./icons/normalized/Interface/External_Link.svg",
    "interface-filter": "./icons/normalized/Interface/Filter.svg",
    "interface-filter-off": "./icons/normalized/Interface/Filter_Off.svg",
    "interface-gift": "./icons/normalized/Interface/Gift.svg",
    "interface-handbag": "./icons/normalized/Interface/Handbag.svg",
    "interface-heart-01": "./icons/normalized/Interface/Heart_01.svg",
    "interface-heart-02": "./icons/normalized/Interface/Heart_02.svg",
    "interface-instance": "./icons/normalized/Interface/Instance.svg",
    "interface-label": "./icons/normalized/Interface/Label.svg",
    "interface-line-l": "./icons/normalized/Interface/Line_L.svg",
    "interface-line-m": "./icons/normalized/Interface/Line_M.svg",
    "interface-line-s": "./icons/normalized/Interface/Line_S.svg",
    "interface-line-xl": "./icons/normalized/Interface/Line_Xl.svg",
    "interface-link": "./icons/normalized/Interface/Link.svg",
    "interface-link-break": "./icons/normalized/Interface/Link_Break.svg",
    "interface-link-horizontal": "./icons/normalized/Interface/Link_Horizontal.svg",
    "interface-link-horizontal-off": "./icons/normalized/Interface/Link_Horizontal_Off.svg",
    "interface-link-vertical": "./icons/normalized/Interface/Link_Vertical.svg",
    "interface-loading": "./icons/normalized/Interface/Loading.svg",
    "interface-lock": "./icons/normalized/Interface/Lock.svg",
    "interface-lock-open": "./icons/normalized/Interface/Lock_Open.svg",
    "interface-log-out": "./icons/normalized/Interface/Log_Out.svg",
    "interface-magnifying-glass-minus": "./icons/normalized/Interface/Magnifying_Glass_Minus.svg",
    "interface-magnifying-glass-plus": "./icons/normalized/Interface/Magnifying_Glass_Plus.svg",
    "interface-main-component": "./icons/normalized/Interface/Main_Component.svg",
    "interface-option": "./icons/normalized/Interface/Option.svg",
    "interface-radio-fill": "./icons/normalized/Interface/Radio_Fill.svg",
    "interface-radio-unchecked": "./icons/normalized/Interface/Radio_Unchecked.svg",
    "interface-search-magnifying-glass": "./icons/normalized/Interface/Search_Magnifying_Glass.svg",
    "interface-settings": "./icons/normalized/Interface/Settings.svg",
    "interface-settings-future": "./icons/normalized/Interface/Settings_Future.svg",
    "interface-shopping-bag-01": "./icons/normalized/Interface/Shopping_Bag_01.svg",
    "interface-shopping-bag-02": "./icons/normalized/Interface/Shopping_Bag_02.svg",
    "interface-shopping-cart-01": "./icons/normalized/Interface/Shopping_Cart_01.svg",
    "interface-shopping-cart-02": "./icons/normalized/Interface/Shopping_Cart_02.svg",
    "interface-slider-01": "./icons/normalized/Interface/Slider_01.svg",
    "interface-slider-02": "./icons/normalized/Interface/Slider_02.svg",
    "interface-slider-03": "./icons/normalized/Interface/Slider_03.svg",
    "interface-star": "./icons/normalized/Interface/Star.svg",
    "interface-suitcase": "./icons/normalized/Interface/Suitcase.svg",
    "interface-swicht-left": "./icons/normalized/Interface/Swicht_Left.svg",
    "interface-swicht-right": "./icons/normalized/Interface/Swicht_Right.svg",
    "interface-tag": "./icons/normalized/Interface/Tag.svg",
    "interface-ticket-voucher": "./icons/normalized/Interface/Ticket_Voucher.svg",
    "interface-trash-empty": "./icons/normalized/Interface/Trash_Empty.svg",
    "interface-trash-full": "./icons/normalized/Interface/Trash_Full.svg",
    "interface-trending-down": "./icons/normalized/Interface/Trending_Down.svg",
    "interface-trending-up": "./icons/normalized/Interface/Trending_Up.svg",
    "media-airplay": "./icons/normalized/Media/Airplay.svg",
    "media-chromecast": "./icons/normalized/Media/Chromecast.svg",
    "media-forward": "./icons/normalized/Media/Forward.svg",
    "media-headphones": "./icons/normalized/Media/Headphones.svg",
    "media-image-01": "./icons/normalized/Media/Image_01.svg",
    "media-image-02": "./icons/normalized/Media/Image_02.svg",
    "media-pause": "./icons/normalized/Media/Pause.svg",
    "media-pause-circle": "./icons/normalized/Media/Pause_Circle.svg",
    "media-play": "./icons/normalized/Media/Play.svg",
    "media-play-circle": "./icons/normalized/Media/Play_Circle.svg",
    "media-rewind": "./icons/normalized/Media/Rewind.svg",
    "media-shuffle": "./icons/normalized/Media/Shuffle.svg",
    "media-skip-back": "./icons/normalized/Media/Skip_Back.svg",
    "media-skip-forward": "./icons/normalized/Media/Skip_Forward.svg",
    "media-stop": "./icons/normalized/Media/Stop.svg",
    "media-stop-circle": "./icons/normalized/Media/Stop_Circle.svg",
    "media-volume-max": "./icons/normalized/Media/Volume_Max.svg",
    "media-volume-min": "./icons/normalized/Media/Volume_Min.svg",
    "media-volume-minus": "./icons/normalized/Media/Volume_Minus.svg",
    "media-volume-off": "./icons/normalized/Media/Volume_Off.svg",
    "media-volume-off-02": "./icons/normalized/Media/Volume_Off_02.svg",
    "media-volume-plus": "./icons/normalized/Media/Volume_Plus.svg",
    "menu-close-lg": "./icons/normalized/Menu/Close_LG.svg",
    "menu-close-md": "./icons/normalized/Menu/Close_MD.svg",
    "menu-close-sm": "./icons/normalized/Menu/Close_SM.svg",
    "menu-hamburger-lg": "./icons/normalized/Menu/Hamburger_LG.svg",
    "menu-hamburger-md": "./icons/normalized/Menu/Hamburger_MD.svg",
    "menu-menu-alt-01": "./icons/normalized/Menu/Menu_Alt_01.svg",
    "menu-menu-alt-02": "./icons/normalized/Menu/Menu_Alt_02.svg",
    "menu-menu-alt-03": "./icons/normalized/Menu/Menu_Alt_03.svg",
    "menu-menu-alt-04": "./icons/normalized/Menu/Menu_Alt_04.svg",
    "menu-menu-alt-05": "./icons/normalized/Menu/Menu_Alt_05.svg",
    "menu-menu-duo-lg": "./icons/normalized/Menu/Menu_Duo_LG.svg",
    "menu-menu-duo-md": "./icons/normalized/Menu/Menu_Duo_MD.svg",
    "menu-more-grid-big": "./icons/normalized/Menu/More_Grid_Big.svg",
    "menu-more-grid-small": "./icons/normalized/Menu/More_Grid_Small.svg",
    "menu-more-horizontal": "./icons/normalized/Menu/More_Horizontal.svg",
    "menu-more-vertical": "./icons/normalized/Menu/More_Vertical.svg",
    "navigation-building-01": "./icons/normalized/Navigation/Building_01.svg",
    "navigation-building-02": "./icons/normalized/Navigation/Building_02.svg",
    "navigation-building-03": "./icons/normalized/Navigation/Building_03.svg",
    "navigation-building-04": "./icons/normalized/Navigation/Building_04.svg",
    "navigation-car-auto": "./icons/normalized/Navigation/Car_Auto.svg",
    "navigation-compass": "./icons/normalized/Navigation/Compass.svg",
    "navigation-flag": "./icons/normalized/Navigation/Flag.svg",
    "navigation-globe": "./icons/normalized/Navigation/Globe.svg",
    "navigation-house-01": "./icons/normalized/Navigation/House_01.svg",
    "navigation-house-02": "./icons/normalized/Navigation/House_02.svg",
    "navigation-house-03": "./icons/normalized/Navigation/House_03.svg",
    "navigation-house-add": "./icons/normalized/Navigation/House_Add.svg",
    "navigation-house-check": "./icons/normalized/Navigation/House_Check.svg",
    "navigation-house-close": "./icons/normalized/Navigation/House_Close.svg",
    "navigation-house-remove": "./icons/normalized/Navigation/House_Remove.svg",
    "navigation-map": "./icons/normalized/Navigation/Map.svg",
    "navigation-map-pin": "./icons/normalized/Navigation/Map_Pin.svg",
    "navigation-navigation": "./icons/normalized/Navigation/Navigation.svg",
    "shape-circle": "./icons/normalized/Shape/Circle.svg",
    "shape-octagon": "./icons/normalized/Shape/Octagon.svg",
    "shape-shield": "./icons/normalized/Shape/Shield.svg",
    "shape-square": "./icons/normalized/Shape/Square.svg",
    "shape-triangle": "./icons/normalized/Shape/Triangle.svg",
    "shape-wavy": "./icons/normalized/Shape/Wavy.svg",
    "system-bar-bottom": "./icons/normalized/System/Bar_Bottom.svg",
    "system-bar-left": "./icons/normalized/System/Bar_Left.svg",
    "system-bar-right": "./icons/normalized/System/Bar_Right.svg",
    "system-bar-top": "./icons/normalized/System/Bar_Top.svg",
    "system-camera": "./icons/normalized/System/Camera.svg",
    "system-code": "./icons/normalized/System/Code.svg",
    "system-cylinder": "./icons/normalized/System/Cylinder.svg",
    "system-data": "./icons/normalized/System/Data.svg",
    "system-desktop": "./icons/normalized/System/Desktop.svg",
    "system-desktop-tower": "./icons/normalized/System/Desktop_Tower.svg",
    "system-devices": "./icons/normalized/System/Devices.svg",
    "system-keyboard": "./icons/normalized/System/Keyboard.svg",
    "system-laptop": "./icons/normalized/System/Laptop.svg",
    "system-mobile": "./icons/normalized/System/Mobile.svg",
    "system-mobile-button": "./icons/normalized/System/Mobile_Button.svg",
    "system-monitor": "./icons/normalized/System/Monitor.svg",
    "system-monitor-play": "./icons/normalized/System/Monitor_Play.svg",
    "system-mouse": "./icons/normalized/System/Mouse.svg",
    "system-moving-desk": "./icons/normalized/System/Moving_Desk.svg",
    "system-printer": "./icons/normalized/System/Printer.svg",
    "system-qr-code": "./icons/normalized/System/Qr_Code.svg",
    "system-save": "./icons/normalized/System/Save.svg",
    "system-tablet": "./icons/normalized/System/Tablet.svg",
    "system-tablet-button": "./icons/normalized/System/Tablet_Button.svg",
    "system-terminal": "./icons/normalized/System/Terminal.svg",
    "system-wifi-high": "./icons/normalized/System/Wifi_High.svg",
    "system-wifi-low": "./icons/normalized/System/Wifi_Low.svg",
    "system-wifi-medium": "./icons/normalized/System/Wifi_Medium.svg",
    "system-wifi-none": "./icons/normalized/System/Wifi_None.svg",
    "system-wifi-off": "./icons/normalized/System/Wifi_Off.svg",
    "system-wifi-problem": "./icons/normalized/System/Wifi_Problem.svg",
    "system-window": "./icons/normalized/System/Window.svg",
    "system-window-check": "./icons/normalized/System/Window_Check.svg",
    "system-window-close": "./icons/normalized/System/Window_Close.svg",
    "system-window-code-block": "./icons/normalized/System/Window_Code_Block.svg",
    "system-window-sidebar": "./icons/normalized/System/Window_Sidebar.svg",
    "system-window-terminal": "./icons/normalized/System/Window_Terminal.svg",
    "user-user-01": "./icons/normalized/User/User_01.svg",
    "user-user-02": "./icons/normalized/User/User_02.svg",
    "user-user-03": "./icons/normalized/User/User_03.svg",
    "user-user-add": "./icons/normalized/User/User_Add.svg",
    "user-user-card-id": "./icons/normalized/User/User_Card_ID.svg",
    "user-user-check": "./icons/normalized/User/User_Check.svg",
    "user-user-circle": "./icons/normalized/User/User_Circle.svg",
    "user-user-close": "./icons/normalized/User/User_Close.svg",
    "user-user-remove": "./icons/normalized/User/User_Remove.svg",
    "user-user-square": "./icons/normalized/User/User_Square.svg",
    "user-user-voice": "./icons/normalized/User/User_Voice.svg",
    "user-users": "./icons/normalized/User/Users.svg",
    "user-users-group": "./icons/normalized/User/Users_Group.svg",
    "warning-circle-check": "./icons/normalized/Warning/Circle_Check.svg",
    "warning-circle-help": "./icons/normalized/Warning/Circle_Help.svg",
    "warning-circle-warning": "./icons/normalized/Warning/Circle_Warning.svg",
    "warning-help": "./icons/normalized/Warning/Help.svg",
    "warning-info": "./icons/normalized/Warning/Info.svg",
    "warning-octagon-check": "./icons/normalized/Warning/Octagon_Check.svg",
    "warning-octagon-help": "./icons/normalized/Warning/Octagon_Help.svg",
    "warning-octagon-warning": "./icons/normalized/Warning/Octagon_Warning.svg",
    "warning-shield-check": "./icons/normalized/Warning/Shield_Check.svg",
    "warning-shield-warning": "./icons/normalized/Warning/Shield_Warning.svg",
    "warning-square-check": "./icons/normalized/Warning/Square_Check.svg",
    "warning-square-help": "./icons/normalized/Warning/Square_Help.svg",
    "warning-square-warning": "./icons/normalized/Warning/Square_Warning.svg",
    "warning-stop-sign": "./icons/normalized/Warning/Stop_Sign.svg",
    "warning-triangle-check": "./icons/normalized/Warning/Triangle_Check.svg",
    "warning-triangle-warning": "./icons/normalized/Warning/Triangle_Warning.svg",
    "warning-warning": "./icons/normalized/Warning/Warning.svg",
    "warning-wavy-check": "./icons/normalized/Warning/Wavy_Check.svg",
    "warning-wavy-help": "./icons/normalized/Warning/Wavy_Help.svg",
    "warning-wavy-warning": "./icons/normalized/Warning/Wavy_Warning.svg"
  }
};
